import { Component, computed, ElementRef, inject, ViewChild } from '@angular/core';
import { InternalAuthService, UtilityService } from '@eforall/common';
import { AppDataService, StaticDataService } from 'services';
import { DashboardPageService } from '../dashboard.page.service';


@Component({
	selector: 'quick-filters-bar-part',
	imports: [],
	templateUrl: './quick-filters-bar.part.html',
	styleUrl: './quick-filters-bar.part.scss',
})
export class QuickFiltersBarPart {

	@ViewChild('menuBtn') menuBtn!: ElementRef;
	@ViewChild('menu') menu!: ElementRef;

	private auth = inject(InternalAuthService);
	private appData = inject(AppDataService);
	private staticData = inject(StaticDataService);
	private util = inject(UtilityService);
	public pageService = inject(DashboardPageService);

	public filters = computed(() => {
		const values = this.pageService.quickFilters();
		return Array.from(values.map.entries())
			.map(([key, value]) => `${key}: ${value}`)
			.sort()
			.join(', ');
	});



}
